import parse from 'html-react-parser';
import dompurify from 'dompurify';

// Converts HTML <br/> tags in a comment string to newline characters (\n).
// Useful for transforming HTML-formatted comments back to plain text where visible line breaks are not needed.
export const parseComment = (comment) => {
    const commentWithEscapedBadBreakLines = comment ? comment.replace(/<br\/>/g, '\n') : '';
    const sanitizedHtmlString = dompurify.sanitize(`<div>${commentWithEscapedBadBreakLines}</div>`, { KEEP_CONTENT: true, WHOLE_DOCUMENT: true });
    return parse(sanitizedHtmlString);
  };

// Converts newline characters (\n) in a comment string to HTML <br/> tags.
// Useful for enabling multiline plain text comments to be displayed with visible line breaks in UI Lib components like HistoryLog
export const parseCommentWithNewLines = (comment) => {
    const commentWithBreaks = comment ? comment.replace(/\n/g, '<br/>') : '';
    return commentWithBreaks;
}

export const sanitizeInfoText = (text) => {
  if (!text) return null;
  
  // Sanitize the HTML to allow only specific tags and attributes
    const cleanHTML = dompurify.sanitize(text, {
      ALLOWED_TAGS: ['strong', 'ul', 'li', 'b', 'i', 'em', 'br', 'span', 'div', 'p'],
      ALLOWED_ATTR: ['style', 'class']
    });
  
  // Create a string that will be rendered as HTML
  return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
};